export const CONST_DETAIL_OPERATOR = {
  LIST_OPERATOR: '運営アカウント一覧',
  OPERATOR_ID: '運営ID',
  OPERATOR_PASSWORD: 'パスワード',
  PASSWORD: '********',
  FIRST_NAME: '姓(セイ)',
  LAST_NAME: 'お名前(カナ)',
  EMAIL: 'メールアドレス',
  EDIT: '編　集',
  LOOKS: '様',
  CONFIRM_DELETE: '選択した運営アカウントを本当に削除しますか？',
  DELETED: '削除しました。',
  PHONE: '電話番号',
};
